import React from 'react';

export default class TogglePanelIconComponent extends React.Component {
  render() {
    const { side, margin, togglePanel } = this.props;

    return (
      <i
        onClick={togglePanel}
        className={`ms-Icon ms-Icon--Chevron${side}Small ms-font-su`}
        style={Object.assign({ marginLeft: `-${margin}px` }, css.style)}
      />
    );
  }
}

const css = {
  style: {
    zIndex: 99,
    cursor: 'pointer',
    textAlign: 'left',
    marginTop: '250px',
    position: 'absolute',
  }
}



// WEBPACK FOOTER //
// ./src/components/LayoutSections/TogglePanelIcon/togglePanelIcon.component.js